/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, March 28th 2024, 11:58:05 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { formatDistance, format } from "date-fns";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

interface DateTimeWithDistanceProps {
  dateTime: string;
  prefix?: React.ReactNode;
}

export const DateTimeWithDistance = ({ prefix, dateTime }: DateTimeWithDistanceProps) => {
  const dateTimeObject = new Date(dateTime);
  return (
    <Tooltip
      title={<Typography>{`${format(dateTimeObject, "EEE dd MMM Y")} ${format(dateTimeObject, "h:mm a")}`}</Typography>}
    >
      <Box sx={{ cursor: "default" }}>
        {prefix ? <>{prefix} </> : null}
        {formatDistance(dateTimeObject, new Date(), { addSuffix: true })}
      </Box>
    </Tooltip>
  );
};
